import {
  Record,
  OrderedMap,
  type RecordOf,
  OrderedSet,
  Map,
  List,
} from 'immutable';
import * as IXUtils from './IXUtils';

type IXStateShape = {
  rawMacros: any;
  macros: any;
};

export type IXState = RecordOf<IXStateShape>;

// @ts-expect-error - TS2322 - Type 'Factory<{ rawMacros: null; macros: OrderedMap<unknown, unknown>; }>' is not assignable to type 'Factory<IXStateType>'.
export const IXState: Record.Factory<IXStateType> = Record(
  {
    // Reference to imported macros array, null indicates pre-import state
    rawMacros: null,

    // guid -> IXMacro map
    macros: OrderedMap(),
  },
  'IXState'
);

export function importRemoteMacros(state: any, {rawMacros = []}: any) {
  return state
    .set('rawMacros', rawMacros)
    .set('macros', IXUtils.reifyIXMacros(rawMacros));
}

export const transformIdentity = Object.freeze({
  x: null,
  y: null,
  z: null,
  scaleX: null,
  scaleY: null,
  scaleZ: null,
  rotateX: null,
  rotateY: null,
  rotateZ: null,
  skewX: null,
  skewY: null,
});

export const transformKeysort = OrderedSet(Object.keys(transformIdentity));

type IXMacroShape = {
  _id: string | null;
  slug: string | null;
  name: string | null;
  value: Map<string, unknown>;
};

export type IXMacro = RecordOf<IXMacroShape>;
export const IXMacro = Record<IXMacroShape>(
  {
    _id: null,
    slug: null,
    name: null,
    value: Map(),
  },
  'IXMacro'
);

export const IXStyle = Record(
  {
    keysort: transformKeysort,
    title: null,
    display: null,
    opacity: null,
    width: null,
    height: null,
    ...transformIdentity,
  },
  'IXStyle'
);

export const IXMacroValue = Record(
  {
    style: IXStyle(),
    triggers: List(),
  },
  'IXMacroValue'
);

export const IXStep = Record(
  {
    _id: null,
    keysort: transformKeysort,
    wait: null,
    title: null,
    display: null,
    opacity: null,
    width: null,
    height: null,
    transition: null,
    ...transformIdentity,
  },
  'IXStep'
);

export const IXTrigger = Record(
  {
    _id: null,
    type: null,
    selector: null,
    descend: false,
    siblings: false,
    preload: false,
    offsetTop: null,
    offsetBot: null,
    loopA: false,
    loopB: false,
    preserve3d: false,
    stepsA: List(),
    stepsB: List(),
  },
  'IXTrigger'
);
